import React, {useState} from "react";
import {RecordsManagementContext} from "./InitialiseContext";

const Records = (props) => {
    // CP stands for Client Portal. Here record is set for client portal
    const [CP_PageDetails, SetCP_PageDetails] = useState({
        Status: '',
        IsCustomerEditEstAftrBook: false,
        EstimateIsDuplicate: '',
        ClientPortalHeader: {CompanyBranchPhnNumber: '', PortalSignature: {}, PortalPayment: {}, InvoicePayment: {}},
        EstimateAndCompanyInfo: {CompanyBranch: {}, Estimate: {}},
        ContactInformation: { CompanyName: '', ContactPersons: [] },
        MovingConsultant: { EstimatedBy: [], BookedBy: [], EstimatedOn: '', BookedOn: '', Verbiage: '' },
        PackingMaterials: { List: [], TotalPrice: '' },
        EstimateStatistics: {},
        EstimateAddress: {},
        EstimateNotes: [],
        ShowRelocationInsurance: false,
        RelocationChecked: false,
        CompanyNote: '',
        ShowEstimateAddendum: '',
        EstimateDetails: {},
        ClientPortalSignature: '',
        PortalPaymentIsDeposit: false,
        InvoiceType: '',
        AddressLatLng: [],
        ScheduledEvents: [],
        date_format: {},
        hideScheduledInfo: false,
        subdomains: [],
        PercentageTip: '',
        TipPromptText: '',
        AddRoomWithMoveSize: true,
        MapKey: ''
    })
// IV1 stands for Invoice 1. Here the record is set for the Digital invoice 1 .
    const [IV1_PageDetails, SetIV1_PageDetails] = useState({
        bol_type: null,
        pdf_est_id: null,
        ServiceDate:"",
        ClientName:"",
        ContactPersons:[],
        TypeOfService:"",
        Origin:{},
        ExtraStops:[],
        Destination:{},
        ImportantNoticeText:"",
        DifficultAccessExceptionText:"",
        Currency: "",
        ArticlePrice: "",
        PricePerPoundPerArticleText: "",
        ShipmentText:"",
        ShipmentText1:"",
        IfStorageAccountAccess:false,
        DifficultAccessHeader: "",
        NoticeText: "",
        TXDMVTEXT1: "",
        TXDMVTEXT2: "",
        StorageAccountAccess:"",
        CustomerSign1: {},
        CustomerSign2: {},
        CustomerSignTexas1:{},
        CustomerSignTexas2:{},
        DriverSign1: {},
        DriverSign2: {},
        Term: "",
        StartEndTime: [],
        DigitalInvoicePagePricingData:{},
        InvoiceNotes:[],
        EventComment: "",
        DeliveryAcknowledgement:"",
        FuelSurCharge:"",
        PackingMaterial: "",
        FuelPrice: "",
        PackingMaterialPrice: "",
        PackingFee: "",
        StorageFee: "",
        DiscountPrice: "",
        AdditionalSurCharges:[],
        AdditionalCharges: [],
        AdditionalChargesSubTotal: [],
        SubTotal: "",
        Tip: "",
        ProcessingFee: {},
        PriceCheckListAdditionalCharges: {},
        PriceCheckListAutomaticValuation: {},
        GrandTotal: {},
        Payment: "",
        BalanceDue: "",
        BackgroundColor: {},
        WarehouseHandling: ""
    })
// IV2 stands for Invoice 2. Here the record is set for the digital invoice 2 .
    const [IV2_PageDetails, SetIV2_PageDetails] = useState({
        bol_type: null,
        pdf_est_id: null,
        CompanyBranchAndEstimateInfo: {},
        ContactPersons: [],
        EstAddress: {},
        PackingAndMovingDates: {},
        PackingMaterials: { List: []},
        NotesAndComments: [],
        EventComment: "",
        TimeRecord: { JobTimes: {} },
        MoveAndPackDetails: {},
        JobDetails: { MovingFee: {}, OvertimeHours: {}, FuelSurcharge: {}, PackingFee: {}, PackingMaterials: {}, StorageFee: {},
            Discount: {}, SubTotal: {}, Tip: {}, CCProcessingFee: {}, SurCharge:{}, Automation: {}, GrandTotal: {}, Payments: {},
            BalanceDue: {}, TruckAndEquipmentFee: {}, EstimateAdditionalChargeSubTotals: [], EstimateAdditionalCharges: [] },
        Signatures: { shipper_sign_3: {}, shipper_sign_4: {}, carrier_sign_1: {}, shipper_sign_5: {}, carrier_sign_2: {},
            shipper_sign_6: {}, carrier_sign_3: {} }
    })
    // Storage Portal Page Details (SP_PageDetails)
    const [SP_PageDetails, SetSP_PageDetails] = useState({
        Status: '',
        Header: { CompanyBranchPhnNumber: '', ButtonColor: { addendums: '#26a9e0', paynow: '#26a9e0', updatebilling: '#6e0000', printstorage: '#26a9e0', signstorage: '#26a9e0' }, ShowAddendums: true, ShowPayNow: true, ShowUpdateBilling: true, ShowPrintStorage: true, ShowSignStorage: true },
        CompanyBranch: { Name: '', Address: '', Mail: '' , SuiteNumber: '', StateAuthority: '', UsDot: '', Logo: '' },
        StorageAccount: { CreatedOn: '', EstimateNumber: '', NextChargeDate: '', AutoPay: '', MonthlyFee: '', Verbiage: '' },
        BillingInfo: {},
        Inventory: { List: [] },
        InventorySummary: { Cuft: '', Lbs: '' },
        Consultant: { Name: '', Email: '', CreatedBy: '', SignaturePic: '' },
        ContactPersons: [],
        BillingHistory: [],
        Notes: '',
        Currency: '',
        Background: { BgColor1: '#172b4d', BgColor2: '#1d4d6e' },
        // New fields to support button logic mirroring Rails implementation
        Addendums: [], // [{id,name}]
        BalanceDue: '', // numeric or formatted string
        StorageSignature: { Signed: false, Url: '', Text: '' }, // to hide sign button if Signed true
        PrintPortal: { url: '', storage_account_id: '' }, // used for print action
        StorageAccountId: '', // fallback id for signature & addendums
        InventoriesEstimates: {Inventories:{}}
    })

    // The state's  set  below is used anywhere in the project , these states are not just limited to the same file where it is defined
    const [modal, setModal] = useState(true) // this state is used to show or hide the modal on the page
    const [SignatureButtonShown,setSignatureButtonShown] = useState(true) // this state is used to show or hide the signature button on the navigation bar(when customer signed the estimate it will set to false)
    const [showSignatureModal,setShowSignatureModal] = useState(false)
    const [RequestMoveDateShown,setRequestMoveDateShown] = useState(true) // this State is used to hide or show the request move date button .
    const [ContactInfoModal,setContactInfoModal] = useState(false) // this state is used to open or close the modal of the "Update Contact Info"
    const [PaymentModal,setPaymentModal] = useState(false) // this state is used to open or close the modal of the "Pay Deposit"
    const [InvoicePaymentModal,setInvoicePaymentModal] = useState(false) // this state is used to open or close the modal of the "Pay Deposit"
    const [SignModal,setSignModal] = useState(false) // this state is used to open or close the modal of the "Sign Estimate"
    const [ESignModal,setESignModal] = useState(false) // this state is used to open or close the modal of the "Verbiage Signatures"
    const [AddressesModal,setAddressesModal] = useState(false) // this state is used to open or close the modal of Update Addresses
    let IsJobBooked = CP_PageDetails.Status === "Job Is Booked"  // this variable is used to check if the Estimate is Booked or not
    let IsJobOpen = CP_PageDetails.Status === "Job Is Open And Not 100%" // this variable is used to check if the estimate is open or not.
    const [SignatureLoad,setSignatureLoad] = useState(false) //used to show loader when esign is loaded.
    const [SelectedAddendum,setSelectedAddendum] = useState('') //used to store selected addendum id
    const [Disblebutton,setDisblebutton] = useState('') //used to store submit buttton disable or enable
    const [showUnsubmitButton,setUnsubmitbutton] = useState('') //used to store selected addendum id
    const [showMap,setShowMap] = useState(false)
    let IsCustomerEditEstAftrBook = CP_PageDetails.IsCustomerEditEstAftrBook || IsJobOpen // This variable is used to check if the estimate is editable or not .
    const [ML_Start,SetML_Start] = useState({
        Status: '', DefaultRoomsName: '', DefaultRoomsId: '', BedroomCount: 0, LastPageVisited: '', CompanyLogo: '', InventoryType: '', CustomerInventoryRequest: {}
    });
    const [DefaultRoomHash, SetDefaultRoomHash] = useState({
        DefaultRoomName: '', DefaultRoomId: '', DefaultEstimateRoomId: '', InventoryHash: {}, customInventoryHash: {}, InventoryQuantities: 0
    });
    const [Room, setRoom] = useState({});
    const [OtherBedrooms, setOtherBedrooms] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const [addManual, setAddManual] = useState(false);
    const [EditRoom, SetEditRoom] = useState(false);
    const [Done, SetDone] = useState(false);
    const [CustomItemDetails, SetCustomItemDetails] =useState('');
    const [CustomItemModal,setCustomItemModal] = useState(false) // this state is used to open or close the modal of Update Addresses
    const [CameraFrom, SetCameraFrom] =useState('');
    const [CaptureImage, SetCaptureImage] =useState('');
    const [CompanyFloors, SetCompanyFloors] =useState({});
    const [EstimateRooms, SetEstimateRooms] = useState({});
    const [RoomsAndInventories, SetRoomsAndInventories] = useState({});
    const [AlertBox, setAlertBox] = useState(false);
    const [ActiveButton, SetActiveButton] = useState(false);
    const [Click, SetClick] = useState('');
    const [RoomInventories, SetRoomInventories] = useState({})
    const [UpdateFloor, SetUpdateFloor] = useState(false)
    const [CrewTipModal,setCrewTipModal] = useState(false) // this state is used to open or close the modal of the "Crew Tip"
    const [TipforCrew, setTipforCrew] = useState(false)
    const [Tip, setTip] = useState('')
    const [FormatVisible, setFormatVisible] = useState(false)
    const [NewTotalCost, setNewTotalCost] = useState('')
    const [NewBalanceDue, setNewBalanceDue] = useState('')
    const [TipValue, setTipValue] = useState('')
    const [TruckArriveTime, setTruckArriveTime] = useState('')
    const [OriginReached, setOriginReached] = useState(false)
    const [hideArrivedMessage, sethideArrivedMessage] = useState(false)
    return (
        <RecordsManagementContext.Provider value={{CP_PageDetails, SetCP_PageDetails, IV1_PageDetails, SetIV1_PageDetails,
            IV2_PageDetails, SignatureButtonShown, RequestMoveDateShown, modal, SetIV2_PageDetails, IsJobBooked, IsJobOpen,
            IsCustomerEditEstAftrBook,PaymentModal,ContactInfoModal, setModal , setPaymentModal,
            setSignatureButtonShown ,SignModal ,SelectedAddendum, Disblebutton, showUnsubmitButton, SignatureLoad, ESignModal,setESignModal,setSignatureLoad ,AddressesModal,
            setAddressesModal, setRequestMoveDateShown,setContactInfoModal,setSignModal,setSelectedAddendum, setDisblebutton, setUnsubmitbutton,setShowMap,showMap,
            Room, setRoom, OtherBedrooms, setOtherBedrooms, DefaultRoomHash, SetDefaultRoomHash, isActive, setIsActive,
            addManual, setAddManual, CustomItemDetails, SetCustomItemDetails, CustomItemModal, setCustomItemModal,
            CompanyFloors, SetCompanyFloors, EstimateRooms, SetEstimateRooms, RoomsAndInventories, SetRoomsAndInventories,
            EditRoom, SetEditRoom, Done, SetDone, CameraFrom, SetCameraFrom, CaptureImage, SetCaptureImage, AlertBox, setAlertBox,
            ActiveButton, SetActiveButton, Click, SetClick, ML_Start, SetML_Start, RoomInventories, SetRoomInventories, UpdateFloor, SetUpdateFloor,
            InvoicePaymentModal, setInvoicePaymentModal, CrewTipModal, setCrewTipModal, TipforCrew, setTipforCrew, Tip, setTip,
            FormatVisible, setFormatVisible, NewTotalCost, setNewTotalCost, NewBalanceDue, setNewBalanceDue, TipValue, setTipValue, TruckArriveTime, setTruckArriveTime,
            OriginReached, setOriginReached, hideArrivedMessage, sethideArrivedMessage, SP_PageDetails, SetSP_PageDetails,showSignatureModal,  setShowSignatureModal}}>
            {props.children}
        </RecordsManagementContext.Provider>
    )
}
export default Records;